import React, { useState, useContext } from 'react';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';
import PartisipantsSlider from '../../partisipantsSlider';
import { useHistory } from 'react-router-dom';
import ControllerContext from '../../../../../RoomControllerSocketContext';
import GradientButton from '../../../../customMui/newButton/newButton';
import { store } from '../../../../../store/store';
import * as roomActions from '../../../../../store/actions/roomActions';
const StartJoining = (props) =>
{
	const { selectedMeeting, userdetails } = props;
	const { pluginSocket } = useContext(ControllerContext);

	console.log('selectedMeeting===', selectedMeeting);
	console.log('userdetails====', userdetails);
	const [ isOpen, setIsOpen ] = useState(false);
	const navigate = useHistory();
	const toggleSlider = () =>
	{
		setIsOpen(!isOpen);
	};

	const closeSlider = () =>
	{
		setIsOpen(false);
	};

	function getTimeRangeString(startTimeMilliseconds, durationMinutes)
	{
		const start = new Date(startTimeMilliseconds);
		const end = new Date(startTimeMilliseconds + durationMinutes * 60000);

		const formatTime = (date) =>
		{
			const hours = date.getHours();
			const minutes = date.getMinutes();
			const ampm = hours >= 12 ? 'PM' : 'AM';
			const formattedHours = hours % 12 || 12; // Convert midnight (0 hours) to 12
			const formattedMinutes = String(minutes).padStart(2, '0');

			return `${formattedHours}:${formattedMinutes} ${ampm}`;
		};

		return `${formatTime(start)} to ${formatTime(end)}`;
	}

	const startMeeting = async () =>
	{
		console.log('ControllerContext..........................', pluginSocket);
		pluginSocket?.emit('startMeeting', selectedMeeting);
		const meetingType = btoa(selectedMeeting?.scheduleType);

		store.dispatch(roomActions.setRoomType(selectedMeeting?.scheduleType));
		store.dispatch(roomActions.setSessionName(selectedMeeting?.meetingName));

		const uid = btoa(userdetails?.data?.email);

		const displayName = btoa(userdetails?.data?.firstName);

		const { controllerUniqueId, desktopUniqueId } = await window?.electron?.ipcRenderer?.invoke('requestToJoinRoom');

		const volume = await window?.electron?.ipcRenderer?.invoke('getSystemVolume');

		pluginSocket?.emit('receiveSystemVolume', { volume });

		navigate.push(`/${selectedMeeting?.sessionId}?projectId=${import.meta.env.VITE_ProjectId}&uid=${uid}&displayName=${displayName}&meetingType=${meetingType}&pairId=${desktopUniqueId}_${controllerUniqueId}&profileKey=${userdetails?.data?.profileImage?.key ? encodeURIComponent(userdetails?.data?.profileImage?.key) : ''}`);
	};

	return (
		<>
			<div className='flexCol wTxt mtngIconsBg brdrRadiusXSM fullH pdngMD scrollYAuto'>
				<div className='flexCol '>
					<span className='fontMD fontWeight500 pdngXS'>{selectedMeeting?.meetingName}</span>
					<span className='fontWeight500 pdngXS fontLG'>
						{getTimeRangeString(selectedMeeting?.startTimeUTC, selectedMeeting?.duration)}
					</span>
					{selectedMeeting?.meetingDescription && <span className='pdngXS colorB2'>{selectedMeeting?.meetingDescription}</span>}
					<span className='pdngXS idcolor'>ID  {selectedMeeting?.uniqueMeetingID}</span>
				</div>

				<div className='flexRow pdngXS'>
					{selectedMeeting?.invities?.length > 0 ?
						<AvatarGroup max={5} className='avatarchange pdngVXS pointer' onClick={toggleSlider}>
							{selectedMeeting?.invities?.map((each, index) => (<Avatar key={each+index}>{each[0]?.toUpperCase()}</Avatar>))}
						</AvatarGroup>
						:
						<p>No Invites</p>}
				</div>
				<div className='pdngXS flexRow aCntr pdngTSM'>
					<GradientButton variant='contained'className='brdrRadiusSM width240' onClick={startMeeting}>START MEETING</GradientButton>
				</div>
			</div>
			<div className={isOpen ? 'overlayS fadeInOverlay' : ''} onClick={toggleSlider} />
			<div className={isOpen ? 'flexCol slider slideIn whiteBg pdngMD' : 'flexCol slider whiteBg'}>
				{isOpen && <PartisipantsSlider open={isOpen} isOpen={isOpen} handleclose={closeSlider} selectedMeeting={selectedMeeting} userdetails={userdetails}/>}
			</div>
		</>
	);
};

export default StartJoining;